import { IconType } from 'react-icons';

export enum EInterventionStatus {
  Complaint = 'complaint',
  DateInspectionRequired = 'date_inspection_required',
  DateRepairInterventionRequired = 'date_repair_intervention_required',
  Expertise = 'expertise',
  ExpertisePlanned = 'expertise_planned',
  InfoClientNeeded = 'info_client_needed',
  InfoInsurerNeeded = 'info_insurer_needed',
  InfoProNeeded = 'info_pro_needed',
  InspectionPlanned = 'inspection_planned',
  Intervention = 'intervention',
  LeakDetectionDateRequired = 'leak_detection_date_required',
  LeakDetectionPlanned = 'leak_detection_planned',
  NoCost = 'no_cost',
  Paid = 'paid',
  PaymentInProgress = 'payment_in_progress',
  ProcessInvoice = 'process_invoice',
  ProcessLeakDetectionReport = 'process_leak_detection_report',
  QualityIssue = 'quality_issue',
  QuoteEvaluation = 'quote_evaluation',
  RepairInterventionPlanned = 'repair_intervention_planned',
  Trashed = 'trashed',
  WaitForLeakDetectionReport = 'wait_for_leak_detection_report',
  WaitingForInvoice = 'waiting_for_invoice',
  WaitingForQuote = 'waiting_for_quote',
}

export enum EInterventionType {
  CostPlus = 'cost_plus',
  LeakDetection = 'leak_detection',
  QuoteNeeded = 'quote_needed',
  UrgentIntervention = 'urgent_intervention',
}

export enum ETypeOfCoverage {
  BurglaryTheft = 'burglary_theft',
  Collision = 'collision',
  Defrosting = 'defrosting',
  Electricity = 'electricity',
  ExplosionImplosion = 'explosion_implosion',
  Fire = 'fire',
  FuelOil = 'fuel_oil',
  GlassDamage = 'glass_damage',
  Scorching = 'scorching',
  SmokeAndRoot = 'smoke_&_root',
  StormHailSnowIce = 'storm_hail_snow_ice',
  Vandalism = 'vandalism',
  WaterDamage = 'water_damage',
  // External categories
  BoilerRepairForBathOrKitchenNoHeating = 'Boiler repair for bath or kitchen (no heating)',
  CarpentrySecuring = 'Carpentry securing',
  Demolition = 'Demolition',
  Dome = 'Dome',
  DrainingAFloodedRoom = 'Draining a flooded room',
  DryingOfARoom = 'Drying of a room',
  ElectricHeating = 'Electric heating',
  Fixing = 'Fixing',
  FlatRoof = 'Flat roof',
  GasHeating = 'Gas heating',
  GutterRainwaterDrainageSecuring = 'Gutter/rainwater drainage securing',
  LeakSecuring = 'Leak securing',
  LockSecuringAfterBurglary = 'Lock securing after burglary',
  NoElectricity = 'No electricity',
  OilHeating = 'Oil heating',
  PlumberLeakSecuring = 'Plumber - leak securing',
  RoofWindow = 'Roof window',
  SlopedRoof = 'Sloped roof',
  UncloggingDrainagePipeSinkShowerBath = 'Unclogging drainage pipe (sink, shower, bath)',
  UncloggingDrainagePipeToilet = 'Unclogging drainage pipe (toilet)',
  UncloggingUndergroundPipesUsingAPumpTruck = 'Unclogging underground pipes (using a pump truck)',
  UnlockingDoorCustomerLockedOut = 'Unlocking door (customer locked out)',
  Window = 'Window',
}

export interface IInterventionTodos {
  due_date: string;
  id: string;
  is_late: boolean;
  todo_status: string;
  todo_type: string;
  urgent: boolean;
}

export interface IInterventionStyles {
  backgroundColor?: string;
  color?: string;
  icon?: IconType;
}

export interface IInterventionCount {
  complaint_count: number;
  cost_plus_date_repair_intervention_required_count: number;
  cost_repair_intervention_planned_count: number;
  date_inspection_required_count: number;
  date_repair_intervention_required_count: number;
  expertise_count: number;
  expertise_date_required_count: number;
  info_client_needed_count: number;
  info_insurer_needed_count: number;
  info_pro_needed_count: number;
  inspection_planned_count: number;
  leak_detection_date_required_count: number;
  leak_detection_planned_count: number;
  new_messages: number;
  no_cost_count: number;
  paid_count: number;
  process_invoice_count: number;
  process_leak_detection_report_count: number;
  quality_issue_count: number;
  quote_date_repair_intervention_required_count: number;
  quote_evaluation_count: number;
  quote_repair_intervention_planned_count: number;
  repair_intervention_planned_count: number;
  trashed_count: number;
  urgent_date_repair_intervention_required_count: number;
  urgent_repair_intervention_planned_count: number;
  waiting_for_invoice_count: number;
  waiting_for_leak_detection_report_count: number;
  waiting_for_quote_count: number;
}

interface IIntervention {
  category_id: number;
  claim_id: number;
  client_address: string;
  created_at: string;
  firstVisitDate: string;
  handler: string;
  id: number;
  insurer: string;
  intervention_type: EInterventionType;
  late?: boolean;
  name: string;
  repair_date: string;
  status: EInterventionStatus;
  styles: IInterventionStyles;
  to_dos: IInterventionTodos[];
  type_of_coverage: ETypeOfCoverage;
}

export default IIntervention;
